/*
 * ready-to-ship-grid.js — Ready to Ship collection grid
 *
 * Cards in sections/collection-ready-to-ship.liquid are rendered by the shared
 * snippets/product-grid-item.liquid, which links to product.url — i.e. the product's
 * DEFAULT variant. On this collection that is actively misleading: a product earns
 * its place in the grid on the strength of a single in_stock variant (Pensive Sofa
 * qualifies on 1 of 250), so the default variant a shopper lands on is usually
 * made-to-order. That mismatch is the exact complaint this collection exists to fix.
 *
 * The section stamps each card with the id of its first in_stock variant. This
 * rewrites that card's own product links to carry ?variant=<id>, so the PDP opens on
 * a configuration that really is ready to ship.
 *
 * Why client-side: the link is built inside snippets/product-grid-item.liquid, which
 * every other collection also uses, and this behaviour must not leak there. Rewriting
 * here keeps the change contained to this one template. It degrades cleanly too —
 * without JS, and for crawlers, cards keep their canonical product URLs.
 */
(function () {
  'use strict';

  function handleOf(href) {
    var rest = href.split('/products/')[1];
    if (!rest) return '';
    return rest.split('?')[0].split('#')[0];
  }

  function apply(root) {
    root.querySelectorAll('[data-rts-card]').forEach(function (card) {
      var id = card.getAttribute('data-rts-variant');
      var handle = card.getAttribute('data-rts-handle');
      if (!id || !handle) return;

      card.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
        var href = a.getAttribute('href');
        if (!href) return;
        if (href.indexOf('variant=') !== -1) return;
        // Cards also carry links to SIBLING products (other colourways). The variant
        // id belongs to this product only — appending it to a sibling's URL would
        // point at a variant that product does not own.
        if (handleOf(href) !== handle) return;
        a.setAttribute('href', href + (href.indexOf('?') === -1 ? '?' : '&') + 'variant=' + id);
      });
    });
  }

  function init() {
    var grid = document.querySelector('[data-rts-grid]');
    if (!grid) return;

    apply(grid);

    // Pagination and filtering re-render the grid over AJAX (pagination-custom is
    // rendered with enable_ajax: true), replacing cards wholesale — re-apply on
    // change. Only attribute writes happen inside apply(), and already-rewritten
    // hrefs are skipped, so a childList observer cannot loop on our own work.
    new MutationObserver(function () { apply(grid); }).observe(grid, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
